import UploadButton, { UploadButtonProps } from './UploadButton';

export type { UploadButtonProps };
export default UploadButton;
